import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import ogImageSmall from '../../Assets/v2/Meta/ogImageSmall.jpg';

const Meta = ({ title, description, link, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      {link && <link rel="canonical" href={link} />}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {/**=== For FaceBook and whatsApp === */}
      <meta property="og:site_name" content="Alien Brains Educations" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content="website" />

      <meta property="og:image" itemProp="image" content={ogImageSmall} />
      <meta property="og:image:width" content="300" />
      <meta property="og:image:height" content="300" />
      <meta property="og:image:type" content="image/jpg" />

      {/**=== For Twitter === */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageSmall} />

      {/**=== For Google+ === */}
      <meta itemprop="name" content={title} />
      <meta itemprop="description" content={description} />
      <meta itemprop="image" content={ogImageSmall} />
    </Helmet>
  );
};

Meta.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
export default Meta;



// WEBPACK FOOTER //
// ./src/Components/Meta/index.js